import { FC } from 'react';
import { format } from 'date-fns';

import { CustomMovement } from 'types';

import { DATE_FORMAT_WITH_TIME } from 'constants/defaultConstants';

import TableRow from 'modules/_shared/Table/components/TableRow';

type CustomMovementsSectionTableRowProps = {
  index: number;
  customMovement: CustomMovement;
};

const CustomMovementsSectionTableRow: FC<
  CustomMovementsSectionTableRowProps
> = ({ index, customMovement }) => {
  const cells = [
    {
      key: `custom-movement-date-${index}`,
      content: format(new Date(customMovement.date), DATE_FORMAT_WITH_TIME),
      className: 'w-150px',
    },
    {
      key: `custom-movement-code-${index}`,
      content: customMovement.code,
      className: 'w-150px',
    },
    {
      key: `custom-movement-description-${index}`,
      content: customMovement.description,
    },
  ];

  return <TableRow cells={cells} />;
};

export default CustomMovementsSectionTableRow;
